<script lang="ts" setup>
	/**
	 * @author Luka Tchigladze
	 */

	
	import { useRouter, useRoute } from "vue-router";

	import SearchAlt from "@/components/regularComponents/UIComponents/SVG/actions/SearchAlt.vue";

	// PROPS
	const props = withDefaults(
		defineProps<{
			placeholderText: string;
			noTranslate?: boolean;
			modelValue?: string | null;
			pushToQuery?: boolean;
		}>(),
		{
			btnText: "Search Flight",
			noTranslate: false,
			pushToQuery: true,
		}
	);

	const router = useRouter();
	const route = useRoute();

	const emit = defineEmits(["update"]);
	let inputTimeout: NodeJS.Timeout;

	const onInput = (e: Event) => {
		const target = e.target as HTMLInputElement;
		const value = target.value?.trim();
		emit("update", value);

		if (!props.pushToQuery) return;

		clearTimeout(inputTimeout);
		inputTimeout = setTimeout(() => {
			router.push({
				query: {
					...route.query,
					searchText: value,
					page: 1,
				},
			});
		}, 500);
	};
</script>

<template>
	<div class="custom-search d-flex j-btw al-center br-4 pos-rel">
		<input
			:value="modelValue"
			:placeholder="
				noTranslate ? placeholderText : $t(placeholderText?.toLowerCase())
			"
			@input="onInput"
		/>

		<SearchAlt class="pointer" />
		<slot name="right" />
	</div>
</template>

<style lang="scss">
	.custom-search {
		height: 66px;
		border: 1px solid $brightGray;
		background-color: transparent;
		@include easeInOut(350ms, all);

		input {
			width: calc(100% - 45px);
			height: 100%;
			padding-left: 16px;

			&::placeholder {
				color: $border-active;
				opacity: 0.6;
				font-size: 15px;
			}
		}

		.icon {
			margin: 0 16px;
		}
	}
</style>
